<template>
  <div class="container">
    <template>
      <h4 class="not-margin"
          :style="{ fontWeight: 'bold', color: 'crimson', fontSize: '18px', textAlign: 'left' }">
        <i class="fad fa-trash-alt" :style="{ width: '25px', fontSize: '18px' }"></i>
        {{ $t("fleetTrucks.delete_truck_title") }}
      </h4>
    </template>
    <div class="field" :style="{marginTop: '20px'}">
      <p>
        {{ $t("fleetTrucks.delete_confirm_question") }}
        <br>
        <span :style="{color: 'grey', fontSize: '13px'}">
          {{ $t("fleetTrucks.delete_confirm_hint") }}
        </span>
      </p>
    </div>
    <div ref="target" id="target" class="center">
      <div class="con-btns">
        <vs-button ref="button" flat danger class="form-btn-loading" :loading="btnLoading"
                   @click="DeleteTruck(truckId)">
          {{ $t("fleetTrucks.confirm_delete") }}
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import MixinFleetTrucks from '@/Mixins/Fleet/Trucks';

export default {
  props: ['truckId'],
  mixins: [MixinFleetTrucks],
};
</script>

<style scoped>
</style>
